import { Injectable } from '@angular/core';
import { WidgetConfigOptions } from '../widget';

@Injectable({
  providedIn: 'root'
})
export class GenericService {

  constructor() { }

  get getDomain(): string {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    return `${protocol}${host}:${port}`
  }

  setPlaceholder(selector: string, placeholder: string) {
    const inputEl = document.querySelector(selector) as HTMLInputElement;
    if(inputEl) {
      inputEl.placeholder = placeholder;
    }
  }  

}

